import { useState } from 'react';
import { Button } from '../ui/Button';
import { Icon } from '../ui/Icon';
import { Modal } from '../ui/Dialog';
import { usePermissions } from '../../features/auth/useAuth';
import { visibleHelp } from '../../features/shell/helpTopics';

/** Stage 7 Phase 2A — in-app help; static, filtered to what the role can open. */
export function HelpButton() {
  const [open, setOpen] = useState(false);
  const permissions = usePermissions();
  const topics = visibleHelp((p) => permissions.can(p));
  return (
    <>
      <button
        type="button"
        aria-label="Help"
        onClick={() => setOpen(true)}
        className="flex h-8 w-8 items-center justify-center rounded-tight text-ink-muted hover:bg-sunken"
      >
        <Icon name="help" className="text-[18px]" />
      </button>
      <Modal
        open={open}
        onOpenChange={setOpen}
        title="Help"
        size="lg"
        footer={<Button variant="secondary" onClick={() => setOpen(false)}>Close</Button>}
      >
        <div className="space-y-4">
          {topics.map((t) => (
            <section key={t.title}>
              <h3 className="text-sm font-semibold text-ink">{t.title}</h3>
              <p className="mt-0.5 text-sm text-ink-muted">{t.body}</p>
            </section>
          ))}
        </div>
      </Modal>
    </>
  );
}
